import { render, staticRenderFns } from "./PhraseStorageList.vue?vue&type=template&id=0e6e0748&"
import script from "./PhraseStorageList.vue?vue&type=script&lang=js&"
export * from "./PhraseStorageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports